import type { CSSProperties } from "react";

import { MEDIA_TYPE, type EmptyMedia } from "./type";

/** 空媒体占位组件，保留旧版尺寸、颜色、图标和提示文案配置。 */
export function ZhEmptyMedia({
    width = "180px",
    height = "120px",
    type = MEDIA_TYPE.IMAGE,
    bgColor = "#F5F5F5",
    color = "#00000066",
    tip,
    fontSize = "14px",
    iconSize = "28px",
    icon,
    iconColor = "#D9D9D9"
}: EmptyMedia) {
    const iconClass = icon || (type === MEDIA_TYPE.VIDEO ? "icon-video" : "icon-picture");
    const tipText = tip || (type === MEDIA_TYPE.VIDEO ? "暂无视频" : "暂无图片");
    const style = {
        width,
        height,
        backgroundColor: bgColor,
        color,
        fontSize
    } as CSSProperties;

    return (
        <div className="media-box" style={style} role="status" aria-label={tipText}>
            <div>
                <i className={`iconfont ${iconClass}`} style={{ color: iconColor, fontSize: iconSize }} />
                <span className="tip">{tipText}</span>
            </div>
        </div>
    );
}

export default ZhEmptyMedia;
